import React from "react";
import { WeeklyDetailsProps } from "src/interfaces/functionalComponentInterface";
import Expandable from "./Expandable";
import { Label } from "./ui/label";
import { TooltipComponent } from "./ui/TooltipComponent";

const WeeklyDetails: React.FC<WeeklyDetailsProps> = ({
  weeksData,
  handleWeekChange,
  numberOfClients,
  totalClients,
  totalAccountValue,
  isActive,
}) => {
  return (
    <div
      className={`flex flex-col items-center z-10 mx-auto max-w-[600px] w-full card-form ${
        isActive ? "show-form" : "hide-form"
      }`}
    >
      <div className="w-full md:px-0">
        <div
          className={`flex flex-row items-center justify-between mt-10
            min-h-[64px] py-[16px] px-[24px] border border-solid rounded-lg 
            ${"bg-[#E7F2FF] border-[#E7F2FF]"}`}
        >
          <div className="flex flex-row items-center gap-[16px] w-full">
            <p className="text-[#1E1E1E] text-[14px] leading-[100%] montserrat font-[700]">
              Client Onboarding Schedule
            </p>
            <TooltipComponent
              id="weekly-client-transitions-tooltip"
              content="Enter the number of client households and their combined account
            value for each week you expect to onboard."
              width={16}
            />
          </div>
        </div>
        <div className="p-6 md:p-10 bg-white border border-[#DFDFDF] rounded-lg">
          <div className="bg-reviewBg border border-[#D8D8D8] flex flex-col md:flex-row justify-between items-center md:w-4xl h-auto md:h-26 p-4 mb-4 rounded-lg gap-2 md:gap-6">
            <div className="flex md:flex-col md:justify-center md:items-center w-full justify-between">
              <Label className="block text-sm md:text-base font-semibold">
                Total Households
              </Label>
              <p className="md:mt-2 text-sm md:text-base font-medium text-gray-800">
                {totalClients}
              </p>
            </div>

            <div className="flex md:flex-col justify-between md:justify-center md:items-center w-full">
              <Label className="block text-sm md:text-base font-semibold">
                Total Account Value
              </Label>
              <div className="md:mt-2 flex items-center text-sm md:text-base font-medium text-gray-800">
                <span>$ {totalAccountValue.toLocaleString()}</span>
              </div>
            </div>
          </div>

          <div className="space-y-4 mb-6 overflow-y-auto">
            {weeksData.map((week, index) => (
              <Expandable
                key={index}
                title={`Week ${index + 1}`}
                weekIndex={index}
                data={week}
                onChange={(weekIndex: number, field: string, value: number) =>
                  handleWeekChange(weekIndex, field, value)
                }
                maxClients={numberOfClients}
                totalClients={totalClients}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklyDetails;
